import {
  Button,
  Grid,
  Heading,
  IconCheckLine,
  InlineList,
  Pill,
  Text,
} from "@instructure/ui";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { FeatureContext, TermsContext } from "../../../../../utils/Context";
import SectionButton from "./SectionButton";
import { dueDateAfterTerm, getDueDate, getTermEndDate } from "./utils";

const SectionHeader = ({
  section,
  cardColor,
  handleSectionSelect,
  reflectionTemplates,
  sectionRefTemplate,
  defaultDeadline,
}) => {
  const { t, i18n } = useTranslation();
  const features = useContext(FeatureContext);
  const { insightsTerms } = useContext(TermsContext);
  const finalizeFlag =
    features.find((f) => f.name === "finalize_results_flag")?.value === "TRUE";
  const dueDate = dueDateAfterTerm(section, defaultDeadline);

  const finalizationDeadline = getDueDate(section.term, dueDate, insightsTerms);
  const termEndDate = getTermEndDate(
    section.term,
    insightsTerms
  )?.toLocaleDateString();

  const formattedDueDate =
    finalizationDeadline &&
    new Intl.DateTimeFormat(i18n.language, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(finalizationDeadline);

  return (
    <Grid startAt="x-large" rowSpacing="small">
      <Grid.Row>
        <Grid.Col>
          <SectionButton
            aria-label={t("dashboard.offeringCardAria", {
              code: section.offering.code,
              term: section.term?.name,
            })}
            onClick={() => handleSectionSelect(section)}
          >
            <Heading as="h3" level="h4">
              <Text wrap="break-word">
                <span style={{ color: cardColor }}>
                  {section.name ??
                    section.offering.code ??
                    t("dashboard.missingSectionName")}
                </span>
                <InlineList delimiter="pipe">
                  <InlineList.Item>{section.offering.code}</InlineList.Item>
                  <InlineList.Item>{section.term?.name}</InlineList.Item>
                </InlineList>
              </Text>
            </Heading>
          </SectionButton>
        </Grid.Col>
        {finalizeFlag && (
          <Grid.Col width="auto" textAlign="end">
            {section.finalized ? (
              <Pill color="success" renderIcon={<IconCheckLine />}>
                {t("finalizeCourse.finalized")}
              </Pill>
            ) : (
              <>
                <Link
                  to="/scores/home"
                  state={{ section, reflectionTemplates, sectionRefTemplate }}
                >
                  <Button size="small">{t("finalizeCourse.finalize")}</Button>
                </Link>
                {formattedDueDate && (
                  <Text
                    as="div"
                    size="small"
                    color="secondary"
                    data-termid={termEndDate}
                  >
                    <Text weight="bold" size="small">
                      {t("resultsDeadline.due")}{" "}
                    </Text>
                    {formattedDueDate}
                  </Text>
                )}
              </>
            )}
          </Grid.Col>
        )}
      </Grid.Row>
    </Grid>
  );
};

export default SectionHeader;
